/*
 * @Author: wuxi
 * @Date: 2022-04-21 17:50:25
 * @LastEditors: wuxi
 * @LastEditTime: 2022-04-21 18:32:36
 * @FilePath: \csx-b2b-front-supplier\components\HOC\product\index.js
 * @Description:商品
 */
import React from 'react';
import { getData } from '@util';
import { Select, Spin } from 'antd';
import { SUPPLIER_BBCPRODUCT_GETBRANDINFO } from '@api';
import { Debounce, Bind } from 'lodash-decorators';
class Product extends React.PureComponent {
  state = {
    AddCodeData: [],
    loading: false,
  };

  componentDidMount() {}

  getAddCodeFunc = value => {
    this.setState({ loading: true, AddCodeData: [] });
    getData({
      api: SUPPLIER_BBCPRODUCT_GETBRANDINFO,
      searchParams: {
        brandDesc: value,
      },
    })
      .then(res => {
        const { data } = res;
        this.setState({
          AddCodeData: data,
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  @Bind()
  @Debounce(1000)
  handleSearch(value) {
    if (!value) return false;
    this.getAddCodeFunc(value);
  }

  render() {
    const { AddCodeData, loading } = this.state;
    const { isSingleSelect, renderValue } = this.props;
    return (
      <Select
        mode={!isSingleSelect && 'tags'}
        tokenSeparators={[' ', ',', '，', '	']}
        optionFilterProp="children"
        allowClear
        filterOption={false}
        notFoundContent={loading ? <Spin size="small" /> : '查询结果为空'}
        onSearch={this.handleSearch}
        showSearch
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            this.props.onChange && this.props.onChange(y);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {AddCodeData.map(item => (
          <Select.Option
            title={`${item.brandCode}&${item.brandDesc}`}
            key={item.brandCode}
            item={item}
            value={
              renderValue ? renderValue(item) : `${item.brandCode}&${item.brandDesc}`
            }>{`${item.brandCode}-${item.brandDesc}`}</Select.Option>
        ))}
      </Select>
    );
  }
}

export default Product;
